import { useEffect, useState } from 'react';
import axios from 'axios';

const useFetch = args => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = config => {
    setIsLoading(true);

    axios(config)
      .then(response => setResponse(response))
      .catch(error => setError(error))
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    fetch(args);
  }, []); // eslint-disable-line

  return { response, error, isLoading, fetch };
};

export default useFetch;
